import React, { useState } from "react";
import { toast } from "sonner";
import "./Contact.css";

const SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbzVnstP_eQNmSwNMU-EeBHRkv8DNa0gwRvXJuiN1VwiJnkfUae0GLAhZ8tMgYkK6WpMrg/exec";

const Contact = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      const params = new URLSearchParams();
      params.append("name", formData.name);
      params.append("email", formData.email);
      params.append("phone", formData.phone);
      params.append("company", formData.company);
      params.append("message", formData.message);
      params.append("page", window.location.href);
      params.append("userAgent", navigator.userAgent);

      // Important: send as form-encoded so Apps Script can read e.parameter
      const res = await fetch(SCRIPT_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: params.toString(),
      });

      // Apps Script returns JSON
      const text = await res.text();
      let json = {};
      try {
        json = JSON.parse(text);
      } catch (err) {}

      if (json && json.ok) {
        toast.success("Message sent successfully! We’ll contact you soon.");
        setFormData({ name: "", email: "", phone: "", company: "", message: "" });
      } else {
        toast.error(json.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const openWhatsApp = () => {
    const phone = "971521034853";
    const text = encodeURIComponent("Hi Fabsome, I’d like to know more.");
    window.open(`https://wa.me/${phone}?text=${text}`, "_blank");
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1 className="contact-hero-title">Get In Touch</h1>
          <p className="contact-hero-subtitle">
            Have questions? We’d love to hear from you. Send us a message and we’ll
            respond as soon as possible.
          </p>
        </div>
      </section>

      <section className="contact-content-section">
        <div className="contact-grid">
          <aside className="contact-info">
            <h2 className="contact-info-title">Contact Information</h2>
            <p className="contact-info-description">
              Reach out to us through any of the following channels. We’re here to help your
              business succeed.
            </p>

            <div className="contact-details">
              <div className="contact-detail-item">
                <div className="contact-detail-icon">📍</div>
                <div className="contact-detail-content">
                  <div className="contact-detail-label">Address</div>
                  <div className="contact-detail-text">
                    M1 Floor, Twin Towers, Fujairah, PO Box 4422, UAE
                  </div>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-detail-icon">📞</div>
                <div className="contact-detail-content">
                  <div className="contact-detail-label">Phone</div>
                  <div className="contact-detail-text">
                    <a href="tel:+971521034853" className="contact-link">
                      +971 52 103 4853
                    </a>
                  </div>
                </div>
              </div>

              <div className="contact-detail-item">
                <div className="contact-detail-icon">✉️</div>
                <div className="contact-detail-content">
                  <div className="contact-detail-label">Email</div>
                  <div className="contact-detail-text">
                    <a href="mailto:info@fabsome.ae" className="contact-link">
                      info@fabsome.ae
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <button className="whatsapp-button" type="button" onClick={openWhatsApp}>
              💬 Chat on WhatsApp
            </button>

            <div className="contact-hours">
              <div className="contact-hours-title">Business Hours</div>
              <div className="contact-hours-text">
                Monday - Friday: 9:00 AM - 7:00 PM <br />
                Saturday: Closed <br />
                Sunday: Closed
              </div>
            </div>
          </aside>

          <div className="contact-form-wrapper">
            <h2 className="contact-form-title">Send us a Message</h2>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-field">
                <label className="form-label">Full Name *</label>
                <input
                  className="form-input"
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field">
                <label className="form-label">Email Address *</label>
                <input
                  className="form-input"
                  type="email"
                  name="email"
                  placeholder="your.email@example.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field">
                <label className="form-label">Phone Number</label>
                <input
                  className="form-input"
                  type="text"
                  name="phone"
                  placeholder="+971 XX XXX XXXX"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-field">
                <label className="form-label">Company Name</label>
                <input
                  className="form-input"
                  type="text"
                  name="company"
                  placeholder="Your company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-field form-field-full">
                <label className="form-label">Message *</label>
                <textarea
                  className="form-textarea"
                  name="message"
                  rows={6}
                  placeholder="Tell us about your inquiry..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field form-field-full">
                <button className="btn-submit" type="submit" disabled={isSubmitting}>
                  {isSubmitting ? "Sending..." : "Send Message"}
                  <span className="btn-icon">➤</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
